import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DIALOG_TYPE } from '../../../constants';
import { Dialog } from '../../../ui';
import { Modal } from '../../../ui/modal/modal';
import {
  AssessmentContext,
  DefaultAssessmentState,
} from '../../../utils/contexts/contexts';
import { BasicInformation } from './form_content/basic_information/basic_information';
import { CreateQuestions } from './form_content/create_questions/create_questions';
import { SettingsAndPermissions } from './form_content/settings_and_permissions/settings_and_permissions';
import { ChooseAssessmentTypeModal } from './modal_content/choose_assessment_type_modal';

export const CreateAssessmentPage = () => {
  const history = useHistory();
  const [assessmentState, setAssessmentState] = useState(
    DefaultAssessmentState.assessmentState,
  );
  const [confirmDialogState, setConfirmDialogState] = useState(false);

  const [modalState, setModalState] = useState<boolean>(
    assessmentState.assessmentType === null,
  );

  const renderFormPage = () => {
    if (
      assessmentState.assessmentType !== null &&
      assessmentState.assessmentPageNo === 1
    ) {
      return <BasicInformation />;
    } else if (assessmentState.assessmentPageNo === 2) {
      return <CreateQuestions />;
    } else if (assessmentState.assessmentPageNo === 3) {
      return <SettingsAndPermissions />;
    }
  };

  const handleModalToggle = () => {
    setModalState(false);
    history.push('/assessment-list');
  };

  // TODO(Joseph): Assessment Page needs to be implemented as per the design
  return (
    <AssessmentContext.Provider
        value={{
          assessmentState: assessmentState,
          setAssessmentState: setAssessmentState,
        }}
    >
      <div className='w-full p-4'>
        { renderFormPage() }

        <ChooseAssessmentTypeModal
            open={modalState}
            onClose={() => {
              setConfirmDialogState(true);
            }}
            onSuccessClose={() => setModalState(false)}
        />
        <Dialog
            title='Are you sure you want to cancel?'
            handleApply={handleModalToggle}
            confirmButtonLable='Yes, Cancel'
            isOpen={confirmDialogState}
            onClose={() => setConfirmDialogState(false)}
            cancelButtonLable='No, Stay'
            dialogType={DIALOG_TYPE.WARNING}
            justify='end'
        >
          <p className='text-primary-textGray text-sm'>
            This action cannot be undone, changes that have you made will be
            lost.
          </p>
        </Dialog>
      </div>
    </AssessmentContext.Provider>
  );
};
